export default "__VITE_ASSET__CIvamlzC__"